import React from 'react';
import GenericSiteDirectContainer from './GenericSiteDirectContainer';

exports.channelMap = {
    audio: props => (<GenericSiteDirectContainer ioChannel="audio" {...props} />),
    display: props => (<GenericSiteDirectContainer ioChannel="display" {...props} />),
    mobile: props => (<GenericSiteDirectContainer ioChannel="mobile" {...props} />),
    native: props => (<GenericSiteDirectContainer ioChannel="native" {...props} />),
    video: props => (<GenericSiteDirectContainer ioChannel="video" {...props} />),
};



// WEBPACK FOOTER //
// ./src/containers/dashboards/siteDirect/index.js